<template>
  <div class="student_box student_bg">
    <header class="flex-align-between student-head">
      <img class="student-logo" src="@/assets/student/student-logo.png">
      <div class="flex-align-center back-box">
        <!-- <img alt="" class="back-ico" src="@/assets/student/back-ico.png" @click="goBack">
        <span class="back-text" @click="goBack">返回</span> -->
        <!-- <div class="logout" @click="logout">退出</div> -->
      </div>
    </header>
    <div class="flex-align-center">
      <div class="student-class-name flex-align-between">
        <div class="dot"></div>
        <div>作品列表</div>
        <div class="dot"></div>
      </div>
    </div>
    <div class="flex-align-center list-work">
      <template v-if="workList.length > 0">
        <div class="item" v-for="(item, index) in  workList " :key="index">
          <div class="file-box flex-column-center">
            <img alt="" class="rating" src="@/assets/student/rating-ico-1.png" v-if="item.integrationLevel == 4">
            <img alt="" class="rating" src="@/assets/student/rating-ico-2.png" v-if="item.integrationLevel == 3">
            <img alt="" class="rating" src="@/assets/student/rating-ico-3.png" v-if="item.integrationLevel == 1">
            <img alt="" class="rating" src="@/assets/student/rating-ico-4.png" v-if="item.integrationLevel == 2">
            <img alt="" class="file" :src="item.filePath">
            <div class="mask"></div>
          </div>
          <div :class="isFinished ? 'view-report' : 'view-report-disabled'" @click="goReport(item.id)">查看报告</div>
        </div>
      </template>
      <el-empty description="暂无作品" v-else></el-empty>
    </div>
    <!-- <div class="ty-bottom">
      <img alt="" class="ty-button" src="@/assets/student/ty-button.png" @click="goUpload">
    </div> -->
  </div>
</template>
<script>
export default {
  components: {},
  name: "StudentListWork",
  data() {
    return {
      numPages: null,
      selectedStudent: null,
      isSubmit: null,
      workList: [],
      client: null,
      intervalId: null,
      isFinished: false,
      eventSource: null
    };
  },
  mounted() {
    this.getStuList();
    this.getStuListInterval()
    let userId = sessionStorage.getItem('padUserId');
    this.initSSE(userId)
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取学生作品列表
    async getStuListInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      this.intervalId = setInterval(async () => {
        let data = {
          studentId: this.$route.query.studentId,
          testId: this.$route.query.testId
        }
        let resData = await this.$Api.StuTest.queryStuUploadList(data);
        console.log('获取学生作品列表', resData);
        this.workList = resData.data;
        if (resData.data.every(item => item.isIdentifyDone == 2)) {
          console.log('所有作品状态完成，清除定时器');
          this.isFinished = true;
          clearInterval(this.intervalId);
        } else {
          this.getStuListInterval()
        }
      }, 3000);
    },
    async getStuList() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      let data = {
        studentId: this.$route.query.studentId,
        testId: this.$route.query.testId
      }
      let resData = await this.$Api.StuTest.queryStuUploadList(data);
      console.log('获取学生作品列表', resData);
      this.workList = resData.data;
      if (resData.data.every(item => item.isIdentifyDone == 2)) {
        console.log('所有作品状态完成，清除定时器');
        this.isFinished = true;
        clearInterval(this.intervalId);
      } else {
        this.getStuListInterval()
      }
    },
    async goUpload() {
      let data = {
        testId: this.$route.query.testId
      }
      let resData = await this.$Api.StuTest.checkStatus(data);
      console.log('查询教师上下课状态', resData);
      if (resData.data == 0) {
        this.$message.error('测评未开始，请稍后再试！');
        return
      }
      if (resData.data == 2) {
        this.$message.error('测评已结束·');
        return
      }
      this.$router.push({
        path: '/student/submitWork',
        query: {
          classId: this.$route.query.classId,
          studentId: this.$route.query.studentId,
          teacherId: this.$route.query.teacherId
        }
      })
    },
    goReport(reportId) {
      if (this.isFinished) {
        // window.open(`https://ssyzpccdn.lezhireading.com//examPaperTest?reportId=${reportId}&type=padReport`)
        // window.open(`https://yun.cnuzi.com/examPaperTest?reportId=${reportId}&type=padReport`)
        let userId = sessionStorage.getItem('padUserId');
        this.$router.push({
          path: '/examPaperTest',
          query: {
            reportId,
            userId,
            type: 'padReport'
          }
        })
      } else {
        this.$message.error('报告暂未生成，请稍后再试！');
      }
    },
    async logout() {
      let data = `testId=${this.$route.query.testId}&studentId=${this.$route.query.studentId}`
      let resData = await this.$Api.StuTest.classOut(data);
      console.log('学生端下课:', resData);
      this.$message.success('退出成功');
      let classId = sessionStorage.getItem('padClassId');
      let t = sessionStorage.getItem('padT');
      let teacherId = sessionStorage.getItem('padTeacherId');
      setTimeout(() => {
        this.$router.push({
          path: '/student/classMates',
          query: {
            testId: this.$route.query.testId,
            classId,
            t,
            teacherId
          }
        });
      }, 1000);
    },
    initSSE(userId) {
      console.log('初始化SSE');
      // this.eventSource = new EventSource(`https://apitest.lezhireading.com/api/learn/open/sse?userId=${userId}`);
      this.eventSource = new EventSource(`https://yunapi.cnuzi.com/api/learn/open/sse?userId=${userId}`);
      this.eventSource.onmessage = (event) => {
        console.log('sse收到消息：', event);
        if (event.data === 'retest') {
          // this.$router.go(-1);
          this.$router.push({
            path: '/student/studentWork',
            query: {
              // testId: this.$route.query.testId,
              // classId: sessionStorage.getItem('padClassId'),
              // t: sessionStorage.getItem('padT'),
              // teacherId: sessionStorage.getItem('padTeacherId'),


              classId: sessionStorage.getItem('padClassId'),
              teacherId: sessionStorage.getItem('padTeacherId'),
              testId: this.$route.query.testId,
              studentId: sessionStorage.getItem('padUserId'),
              className: sessionStorage.getItem('padClassName'),
              studentName: sessionStorage.getItem('padStudentName')
            }
          })
        }
      };
      this.eventSource.onerror = (err) => {
        console.error('SSE 出错或断开:', err);
      };
    },
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.eventSource) {
      this.eventSource.close();
    }
  },
};
</script>

<style lang="less" scoped>
@import "student.less";

/deep/ .el-empty__description p {
  font-size: 26px;
}
</style>
<style></style>
